import { apiFetch } from './client'

export interface OrderDetail {
  reference: string
  status: string
  plan_id: string
  email: string
  amount_cents: number
  currency: string
  created_at: string
  updated_at: string
  qr_code_url: string | null
  qr_code_data: string | null
}

interface OrderListResponse {
  orders: OrderDetail[]
  total: number
  page: number
  per_page: number
}

export async function listOrders(page = 1, per_page = 20): Promise<OrderListResponse> {
  return apiFetch<OrderListResponse>(`/api/orders?page=${page}&per_page=${per_page}`)
}

export interface OrderUsage {
  used_mb: number | null
  total_mb: number | null
  left_mb: number | null
  percent: number | null
  activated_at: string | null
  expires_at: string | null
  // Whether the plan's clock has actually started (first data connection).
  // Until it does, `expires_at` is the deadline to connect, not the end of
  // the plan — see the note on the backend's OrderUsageResponse.
  plan_started: boolean
  // Raw bytes consumed. A first network attach is tens of KB, which rounds
  // to 0 MB while being exactly what starts the plan — show this instead
  // when the figure is sub-megabyte.
  used_bytes: number | null
  // What the profile is doing on the handset, per JoyTel.
  profile_state: 'ENABLED' | 'DISABLED' | 'DELETED' | null
  state: 'unused' | 'active' | 'expired' | 'depleted' | 'unknown'
  // Install-lifecycle signals, may be null if JoyTel hasn't provided
  // either the push (install events) or pull (status query) signal yet.
  esim_status: 'unknown' | 'activated' | 'expired' | null
  installed_at: string | null
  enabled_at: string | null
  // Where the bytes were actually spent, biggest first. `name` falls back to
  // "MCC 623" for an unmapped code and `flag` is then empty — the backend
  // never guesses a country here.
  usage_by_country: UsageCountry[]
}

export interface UsageCountry {
  code: string | null
  name: string
  flag: string
  bytes: number
}

export async function fetchOrderUsage(reference: string): Promise<OrderUsage> {
  return apiFetch<OrderUsage>(`/api/orders/${encodeURIComponent(reference)}/usage`)
}
